import React, { useState, useEffect } from 'react';

import searchIco from "../../../assets/icons/interface/search.svg";
import closeIco from "../../../assets/icons/close_modal.svg";
import pinIco from "../../../assets/icons/interface/mapPin.svg"; // Добавляем импорт иконки
import micIco from "../../../assets/icons/interface/mic.svg"; // Добавляем импорт иконки

// Импортируем иконки для каждой категории
import beachesIco from '../../../assets/icons/interface/beaches.svg';
import hotelIco from '../../../assets/icons/interface/hotel.svg';
import entertainmentIco from '../../../assets/icons/interface/entertainment.svg';
import bankCategoryIco from '../../../assets/icons/interface/bank.svg';
import societyIco from '../../../assets/icons/interface/society.svg';
import barIco from '../../../assets/icons/interface/bar.svg';
import fastfoodIco from '../../../assets/icons/interface/fastfood.svg';
import restaurantIco from '../../../assets/icons/interface/restaurant.svg';
import shopIco from '../../../assets/icons/interface/shop.svg';
import educationIco from '../../../assets/icons/interface/education.svg';
import estateIco from '../../../assets/icons/interface/estate.svg';
import otherIco from '../../../assets/icons/interface/other.svg';
import clockIco from "../../../assets/icons/interface/clock.svg";

const SearchComponent = ({
                             onClose,
                             roadsData,
                             setSelectedMarker,
                             pointType,
                             onSelectRoutePoint,
                             showRouteSelect = false,
                             userPosition
                         }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showZaglushka, setShowZaglushka] = useState(true);
    const [logoLoadStatus, setLogoLoadStatus] = useState({});
    //console.log("SearchComponent userPosition:", userPosition);
    // Добавьте эту функцию внутри компонента SearchComponent
    const isOpenNow = (operatingHours) => {
        if (!operatingHours || !operatingHours.start || !operatingHours.end) return true; // Если нет данных, считаем открытым

        const now = new Date();
        const currentHours = now.getHours();
        const currentMinutes = now.getMinutes();

        // Преобразуем время из строк "HH:MM" в минуты
        const startParts = operatingHours.start.split(':');
        const endParts = operatingHours.end.split(':');

        const startMinutes = parseInt(startParts[0]) * 60 + parseInt(startParts[1]);
        const endMinutes = parseInt(endParts[0]) * 60 + parseInt(endParts[1]);
        const nowMinutes = currentHours * 60 + currentMinutes;

        return nowMinutes >= startMinutes && nowMinutes <= endMinutes;
    };

    // Функция для форматирования времени
    const formatTime = (operatingHours) => {
        if (operatingHours && operatingHours.start && operatingHours.end) {
            return `${operatingHours.start}-${operatingHours.end}`;
        }
        return "Уточняется";
    };

    // Маппинг категорий с их форматированными названиями
    const categoryNames = {
        "beaches": "Пляжи и клубы",
        "hotel": "Отели",
        "entertainment": "Развлечения",
        "bank": "Банки и банкоматы",
        "society": "Сервис и услуги",
        "sport": "Спорт",
        "food": "Рестораны",
        // "bar": "Бары",
        // "fastfood": "Фастфуд",
        // "restaurant": "Рестораны",
        "shop": "Магазины",
        "education": "Дети и обучение",
        "estate": "Недвижимость",
        "other": "Другое"
    };

    // Маппинг категорий с их иконками
    const categoryIcons = {
        "beaches": beachesIco,
        "hotel": hotelIco,
        "entertainment": entertainmentIco,
        "bank": bankCategoryIco,
        "society": societyIco,
        "bar": barIco,
        "fastfood": fastfoodIco,
        "restaurant": restaurantIco,
        "shop": shopIco,
        "education": educationIco,
        "estate": estateIco,
        "other": otherIco
    };

    // Очистить поле поиска
    const handleClearSearch = () => {
        setSearchTerm('');
        setSearchResults([]);
        setShowZaglushka(true);
    };

    // Функция поиска
    useEffect(() => {
        if (!roadsData || !searchTerm.trim()) {
            setSearchResults([]);
            setShowZaglushka(true);
            return;
        }

        const term = searchTerm.toLowerCase().trim();

        // Поиск точек (маркеров) в GeoJSON
        const points = roadsData.features.filter(feature =>
            feature.geometry.type === 'Point' &&
            (
                (feature.properties.name && feature.properties.name.toLowerCase().includes(term)) ||
                (feature.properties.description && feature.properties.description.toLowerCase().includes(term)) ||
                (feature.properties.category && feature.properties.category.toLowerCase().includes(term)) ||
                (feature.properties.tags && feature.properties.tags.toLowerCase().includes(term))
            )
        );
        setSearchResults(points.map(point => point.properties));
        const mappedResults = points.map((feature) => {
            const [lng, lat] = feature.geometry.coordinates; // "Point" => [lng, lat]
            // Объединяем properties и координаты в один объект
            return {
                ...feature.properties,
                lat,
                lng
            };
        });
        setSearchResults(mappedResults);
        setShowZaglushka(points.length === 0);
    }, [searchTerm, roadsData]);

    // Обработчик выбора результата
    const handleSelectResult = (result) => {
        // Находим соответствующий маркер в данных
        const selectedFeature = roadsData.features.find(feature =>
            feature.geometry.type === 'Point' &&
            feature.properties.name === result.name &&
            feature.properties.description === result.description &&
            feature.properties.tags === result.tags
        );

        if (selectedFeature) {
            // Устанавливаем выбранный маркер для дальнейшей обработки
            setSelectedMarker(selectedFeature);

            // Закрываем модальное окно
            onClose();
        }
    };

    // Новый обработчик выбора результата для маршрута
    const handleSelectRoutePoint = (result) => {
        console.log(`Выбрана точка ${pointType}:`, result);

        if (onSelectRoutePoint) {
            onSelectRoutePoint(result, pointType);
            onClose();
        } else {
            // Если обработчик не передан, используем стандартный
            handleSelectResult(result);
        }
    };

    // Обработчик ошибки загрузки изображения
    const handleImageError = (index) => {
        setLogoLoadStatus(prev => ({
            ...prev,
            [index]: false
        }));
    };

    // Обработчик успешной загрузки изображения
    const handleImageLoad = (index) => {
        setLogoLoadStatus(prev => ({
            ...prev,
            [index]: true
        }));
    };

    // Добавляем useEffect для сброса состояния при изменении данных
    useEffect(() => {
        setLogoLoadStatus(true); // Сбрасываем флаг при получении новых данных
    }, [roadsData]);


    return (
        <div className="container">
            <div className="container__header">
                <h1>{pointType === "start" ? "Откуда" : pointType === "end" ? "Куда" : "Поиск"}</h1>
                <div className="search__select-point">
                    <img src={searchIco} alt="Search Icon"/>
                    <input
                        type="text"
                        className="search__select-text search__select-text--selected"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Поиск по объектам"
                    />
                    {searchTerm && (
                        <img
                            className={"search__select-close"}
                            src={closeIco}
                            alt="Close Icon"
                            onClick={handleClearSearch}
                        />
                    )}
                </div>

                {showRouteSelect && ( // Если showRouteSelect=true, отображаем доп выбор точки маршрута
                    <div className="search-route__select">
                        <button className="search-route__item"onClick={() => {
                            console.log("Button clicked, userPosition:", userPosition);

                            if (!userPosition) {
                                console.log("userPosition is undefined!");
                                return;
                            }

                            // Let's check the format and structure
                            console.log("userPosition type:", typeof userPosition);
                            console.log("userPosition is array:", Array.isArray(userPosition));

                            // Extract lat/lng safely
                            let lat, lng;
                            if (Array.isArray(userPosition) && userPosition.length >= 2) {
                                [lat, lng] = userPosition;
                            } else if (userPosition.lat && userPosition.lng) {
                                lat = userPosition.lat;
                                lng = userPosition.lng;
                            } else {
                                console.error("Unknown userPosition format:", userPosition);
                                return;
                            }

                            const myPositionResult = {
                                name: "Моя позиция",
                                updatable: true,
                                lat,
                                lng,
                            };

                            console.log("About to call handleSelectRoutePoint with:", myPositionResult);
                            handleSelectRoutePoint(myPositionResult);
                        }}
                        >
                            <img src={pinIco} alt="Pin Icon"/>
                            <text className="search-route__item-text">Моя позиция</text>
                        </button>
                        <button className="search-route__item">
                            <img src={micIco} alt="Mic Icon"/>
                            <text className="search-route__item-text">Голосом</text>
                        </button>
                    </div>
                )}

            </div>
            <div className="container__body">
                <div className="search__wrapper">
                    {searchResults.length > 0 ? (
                        searchResults.map((result, index) => {
                            // Формируем путь к логотипу, если указан markerIconName
                            const logoPath = result.markerIconName ?
                                `/icons/round_logo/${result.markerIconName}.png` : null;

                            // Получаем категорию или используем "other" по умолчанию
                            const category = (result.category || 'other').toLowerCase();

                            // Получаем форматированное название категории
                            const formattedCategory = categoryNames[category] || categoryNames.other;

                            // Получаем иконку для категории
                            const categoryIcon = categoryIcons[category] || categoryIcons.other;

                            // Получаем форматированное время работы
                            const timeDisplay = formatTime(result.operatingHours);

                            // Определяем класс для времени работы
                            const timeClassName = `search__item-info-bubble-time ${!isOpenNow(result.operatingHours) ? 'closed' : ''}`;


                            return (
                                <div
                                    key={index}
                                    className="search__item"
                                    onClick={() => pointType ? handleSelectRoutePoint(result) : handleSelectResult(result)}
                                >
                                    <div className="search__item-info">
                                        <h2>{result.name || "Н/Д"}</h2>
                                        <div className="search__item-info-bubbles">
                                            <text className={timeClassName}>
                                                <img src={clockIco} alt="Clock Icon"/>
                                                {timeDisplay}
                                            </text>
                                            <text className="search__item-info-bubble-cathegory">
                                                <img src={categoryIcon} alt="Category Icon"/>
                                                {formattedCategory}
                                            </text>
                                        </div>
                                    </div>
                                    {logoPath && (
                                        <div className="search__item-logo__container">
                                            <img
                                                src={logoPath}
                                                alt={`${result.name} Logo`}
                                                onError={() => handleImageError(index)}
                                                onLoad={() => handleImageLoad(index)}
                                                style={logoLoadStatus[index] === false ? {display: 'none'} : {}}
                                            />
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div className={`search__zaglushka ${!searchTerm || showZaglushka ? '' : 'visually-hidden'}`}>
                            <img src={searchIco} alt="Search Icon"/>
                            <text>Введите название заведения или тематику <br/><br/>Например "национальная еда" или "круглосуточный супермаркет".
                            </text>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SearchComponent;